import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/_site/privacy-policy")({
  head: () => ({
    ...seo({
      title: "Privacy Policy | Kodiak Structures & Exteriors",
      description:
        "Privacy Policy for Kodiak Structures & Exteriors. Learn how we collect, use, and protect your personal information.",
      path: "/privacy-policy",
    }),
  }),
  component: PrivacyPolicy,
});
